import { createSlice } from "@reduxjs/toolkit";
import { getFromLocalStorage } from "config/functions";
import { MANAGER } from "config/roles";

const checkUserRoleByCallEmpId = (id) => {
  let value = false
  const user = getFromLocalStorage("user");
  if (MANAGER.includes(user?.userRole) || user?.id === id)
    value = true
  return value

}

const servicesCallSlice = createSlice({
  name: "servicesCall",
  initialState: {
    list: [],
    openCreateServices: false,
    servicesCallDetails: null,
    callBackData: null
  },
  reducers: {
    setList(state, action) { state.list = action.payload },
    setOpenCreateServices(state, action) { state.openCreateServices = action.payload },
    setServicesCallDetails(state, action) { state.servicesCallDetails = action.payload },
    setCallBackData(state, action) { state.callBackData = action.payload },

    newServicesCall(state, action) {
      let newList = [...state.list]

      const jsonStart = action.payload.indexOf('{');
      const jsonString = action.payload.substring(jsonStart);
      const data = JSON.parse(jsonString)

      const hasId = newList?.some(item => item?._id === data?._id)
      if (!hasId)
        newList.push(data)
      state.list = newList
    },

    editServicesCall(state, action) {
      let newList = [...state.list]

      const jsonStart = action.payload.indexOf('{');
      const jsonString = action.payload.substring(jsonStart);
      const data = JSON.parse(jsonString)

      let findIndex = newList.findIndex((i) => i._id === data?._id);
      const hasIndex = findIndex === -1 ? false : true

      if (hasIndex && !checkUserRoleByCallEmpId(data?.employee))
        newList = newList?.filter(item => item?._id !== data?._id)

      else if (hasIndex)
        newList[findIndex] = data;

      else if (!hasIndex && checkUserRoleByCallEmpId(data?.employee)) {
        newList.push(data)
      }

      state.list = newList
    },

    removeServicesCall(state, action) {
      const list = [...state.list]

      const jsonStart = action.payload.indexOf('{');
      const jsonString = action.payload.substring(jsonStart);
      const data = JSON.parse(jsonString)

      const newList = list?.filter(item => item?._id !== data?.id)
      state.list = newList
    },
  },
});

export const {
  setList,
  setOpenCreateServices,
  setServicesCallDetails,
  setCallBackData,
  newServicesCall,
  removeServicesCall,
  editServicesCall,
} = servicesCallSlice.actions;
export default servicesCallSlice.reducer;
